<template>
  <div class="product">
    <div class="thumb-example">
      <iframe src="../../static/html/swiper.html"  frameborder="0" scrolling="no" name="mailIframe" id="mailIframe"></iframe>
    </div>
    <div class="content">
      <p class="position">您所在的位置：首页 > 产品展厅</p>
      <!-- 智慧工地 -->
      <div class="list">
        <div class="title">
          智慧安防
        </div>
        <div class="projectList">
          <div class="img">
            <!-- <img :src="url + '/assets/product/class-site.png'"> -->
            <img :src="url + '/assets/product/security.jpg'">

          </div>
           <swiper class="swiper swiperPrpduct" ref="swiper" :options="swiperOption">
              <swiper-slide  class="slide" v-for="(item, index) in list" :key="index">
                  <div class="img3">
                    <img :class="{ p1: index == 0, p2: index == 1, p3: index == 2, p10: index == 3 }" :src="item.img">
                    <p class="text">{{item.text}}</p>
                </div>
              </swiper-slide>
               <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
      <!-- 智慧警务 -->
      <div class="list" v-for="(item, index) in listArr" :key="index">
        <div class="title">
          {{item.title}}
        </div>
        <div class="projectList">
          <div class="img">
            <img :src="url + '/assets/product/class-police.png'" v-if="item.title === '智慧警务'">
            <img :src="url + '/assets/product/class-park.png'" v-else>
          </div>
           <div class="img2"  v-for="(img, index) in item.list" :key="index">
              <img :class="{ p4: index == 0, p5: index == 1, p6: index == 2, p7: index == 3, p8: index == 4, p9: index == 5 }" :src="img.img">
              <p class="text">{{img.text}}</p>
          </div>
        </div>
      </div>
    </div>
     <foot></foot>
  </div>
</template>
  <script src="https://www.swiper.com.cn/package/swiper-bundle.min.js"></script>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import foot from '../components/foot'
import defaultSettings from '@/defaultSettings'
// const img1 = defaultSettings.url + '/assets/product/p1.png'
// const img2 = defaultSettings.url + '/assets/product/p2.png'
// const img3 = defaultSettings.url + '/assets/product/p3.png'
const img1 = defaultSettings.url + '/assets/product/p-1.jpg'
const img2 = defaultSettings.url + '/assets/product/p-2.jpg'
const img3 = defaultSettings.url + '/assets/product/p-3.jpg'
const img10 = defaultSettings.url + '/assets/product/p-4.jpg'
const img4 = defaultSettings.url + '/assets/product/p4.png'
const img5 = defaultSettings.url + '/assets/product/p5.png'
const img6 = defaultSettings.url + '/assets/product/p6.png'
const img7 = defaultSettings.url + '/assets/product/p7.png'
const img8 = defaultSettings.url + '/assets/product/p8.png'
const img9 = defaultSettings.url + '/assets/product/p9.png'


export default {
  components: {
    Swiper,
    SwiperSlide,
    foot
  },
  data() {
    return {
      url: defaultSettings.url,
      list: [
        {
          img: img1,
          text: '感知版'
        },
        {
          img: img2,
          text: '瞭望版'
        },
        {
          img: img3,
          text: '巡视版'
        },
        {
          img: img10,
          text: '旗舰版'
        },
      ],
      listArr: [
        {
          title: '智慧警务',
          list: [
            {
              img: img4,
              text: '数据大屏',
            },
            {
              img: img5,
              text: '智能终端'
            },
            {
              img: img6,
              text: '车载GPS定位'
            },
          ]
        },
        {
          title: '智慧园区',
          list: [
            {
              img: img7,
              text: '数据大屏'
            },
            {
              img: img8,
              text: '人脸识别PAD'
            },
            {
              img: img9,
              text: '闸机'
            }
          ]
        }
      ],
      swiperOption: {
        //   loop: true,
          //   自动轮播
        //   autoplay: {
        //     delay: 3000,
        //     stopOnLastSlide: false,
        //     /* 触摸滑动后是否继续轮播 */
        //     disableOnInteraction: false,
        //   },
          slidesPerView: 4,
          spaceBetween: 30,
          direction: 'horizontal',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          on: {
            resize: () => {
              this.$refs.swiper.$swiper.changeDirection(
                window.innerWidth <= 960
                  ? 'vertical'
                  : 'horizontal'
              )
            }
          }
        },
    };
  },
  mounted() {
    console.log(defaultSettings.url)
    window.scrollTo({ left: 0, top: 0 })
  },
};
</script>

<style lang="less" scoped>
#mailIframe{
  width:100%;
  height:520px;
}
.slide{
  width:198px!important;
  height:350px;
  margin:0 15px!important;
  .img3{
        transition: all 0.6s;
        width:220px;
        background: #fff;
        height:350px;
        margin:0 12px 30px 12px;
        text-align: center;
        position: relative;
        .p1{
          width:190px;
          height:125px;
          padding-top:75px;
        }
        .p2{
          width:175px;
          height:198px;
          padding-top:45px;
        }
        .p3{
          width:130px;
          height:230px;
          padding-top:25px;
        }
         .p10{
          width:130px;
          height:230px;
          padding-top:25px;
        }
        .text{
          background: #F6AA08;
          width:280px;
          height:66px;
          line-height:66px;
          text-align: center;
          color:#fff;
          font-size:18px;
          position: absolute;
          width:100%;
          bottom:0;
          opacity: 0;
          transition: all 0.6s;
        }
      }
      .img3:hover{
         .text{
          opacity: 1;
          transition: all 0.6s;
          transform: translate(0,-8px);
        }
      }
}
.product {
  background: #f6f6f6;
  // height:100vh;
  height: 100%;
  position: relative;
  overflow: auto;
  padding-top: 90px;
}
.thumb-example {
  // height: 450px;
}

.content {
  width: 1200px;
  margin: -55px auto 0;
  .position {
    margin-top: 25px;
    color: #999999;
    font-size: 14px;
    margin-bottom: 50px;
  }
  .list{
    .title{
      color:#333;
      font-size:24px;
      text-align: left;
      margin-bottom:25px;
    }
    .projectList{
      display: flex;
      .img{
        width:280px;
        height:350px;
        margin:0 12px 30px 12px;
        img{
          width:100%;
        }
      }
      .img2{
        transition: all 0.6s;
        width:280px;
        background: #fff;
        height:350px;
        margin:0 12px 30px 12px;
        text-align: center;
        position: relative;
        .p4{
          width:238px;
          height:240px;
          padding-top:30px;
        }
        .p5{
          width:160px;
          height:200px;
          padding-top:40px;
        }
        .p6{
          width:240px;
          height:190px;
          padding-top:50px;
        }
        .p7{
          width:238px;
          height:164px;
          padding-top:50px;
        }
        .p8{
          width:120px;
          height:220px;
          padding-top:30px;
        }
        .p9{
          width:207px;
          height:175px;
          padding-top:50px;
        }
        .text{
          background: #F6AA08;
          width:280px;
          height:66px;
          line-height:66px;
          text-align: center;
          color:#fff;
          font-size:18px;
          position: absolute;
          width:100%;
          bottom:0;
          opacity: 0;
          transition: all 0.6s;
        }
      }
      .img2:hover{
         .text{
          opacity: 1;
          transition: all 0.6s;
          transform: translate(0,-8px);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product.vue